import { DOCUMENT_LANG } from 'js/core/constants';
import 'hyperform-l10n/dist/hyperform.nl';
hyperform.setLanguage(DOCUMENT_LANG);

const suluForms = document.querySelectorAll('form[name^="dynamic_form"]');

if (suluForms.length > 0) {
    suluForms.forEach((form) => {
        hyperform(form, {
            revalidate: 'hybrid',
            validEvent: true,
        });
    });

    hyperform.setRenderer('attachWarning', (warning, element) => {
        element.parentNode.appendChild(warning);
    });
}
